'use strict';

export function mainMenuInit() {
  const toggles = document.querySelectorAll('.submenu-toggle');

  toggles.forEach(toggle => {
    const submenuId = toggle.getAttribute('aria-controls');
    const submenu = document.getElementById(submenuId);

    // Kliknięcie: otwórz/zamknij
    toggle.addEventListener('click', function (event) {
      // event.preventDefault();
      const isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      // Zamknij inne
      toggles.forEach(other => {
        if (other !== toggle) {
          const otherSub = document.getElementById(
            other.getAttribute('aria-controls')
          );
          other.setAttribute('aria-expanded', 'false');
          otherSub.setAttribute('aria-hidden', 'true');
          otherSub.classList.remove('active');
        }
      });

      // Toggle aktualnego
      toggle.setAttribute('aria-expanded', String(!isExpanded));
      submenu.setAttribute('aria-hidden', String(isExpanded));
      submenu.classList.toggle('active', !isExpanded);
    });

    // Kursor zjechał z przycisku
    toggle.addEventListener('mouseleave', () => {
      if (document.querySelector('.page-header__menu-mobile')) return;
      toggle.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      submenu.classList.remove('active');
    });

    // Kursor zjechał z samego panelu submenu
    submenu.addEventListener('mouseleave', () => {
      toggle.setAttribute('aria-expanded', 'false');
      submenu.setAttribute('aria-hidden', 'true');
      submenu.classList.remove('active');
    });
  });
}
